import blog1 from "@assets/images/meeting-with-client-for-gathering-requirements.avif";
import blog2 from "@assets/images/brainstorming-the-best-software-solutions.avif";
import blog3 from "@assets/images/website-designers-discussing-low-fidelity-mockups.avif";
import blog4 from "@assets/images/coding-on-a-computer.avif";
import blog5 from "@assets/images/software-testing.avif"; 

export const process = [ 
  {
    title: "Discovery & Documentation",
    image: blog1,
    description:
      " Defining the requirements and blueprint to ensure long-term scalability.",
  },
  {
    title: "System & UX Design",
    image: blog2,
    description:
      "Crafting system architecture and intuitive interfaces that honor both Apple’s Human Interface and Google’s Material Design guidelines.",
  },
  {
    title: "Agile Development",
    image: blog3,
    description:
      "Delivering features through rapid sprints to maximize developer velocity and maintain client transparency.",
  },
  {
    title: "Quality Assurance (QA)",
    image: blog4,
    description:
      " Rigorous testing across various hardware to ensure 60 FPS performance and zero lag.",
  },
  {
    title: "Launch & Support",
    image: blog5,
    description:
      "Deployment to app stores followed by proactive maintenance to prevent technical debt.",
  },
 
 
]; 